export default __webpack_public_path__ + "static/media/pinkFlower.5a5ad086.jpg";